var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { TextComponent, KRWFomatToString, KRWFomatWithoutWon, ClickableText, EntireLoader, XScrollableTable, getSalesTableColumns } from 'renderer/components';
import { UsingHistoryModel, TicketModel, EXTENDED_SALES_METHODS, SALES_TYPES, MANAGER_PERMISSION_KEYS, MANAGER_PERMISSION_ACTIONS_DURATION } from 'renderer/models';
import Row from 'antd/lib/row';
import { PaymentHistoryQuery, ManagerQuery } from 'renderer/queries';
import * as dayjs from 'dayjs';
import { COLORS } from 'renderer/styles';
import { floor, orderBy, sum, isEmpty, useWindowSize, uniq } from 'renderer/utils';
import Empty from 'antd/lib/empty';
import { CustomedPieChart, LegendItem, StatisticRemoteController } from './StatUsing';
import Col from 'antd/lib/col';
import { SalesHistoryModel } from 'renderer/models';
import clsx from 'clsx';
import * as Styles from './styles.css';
import { useRecoilState } from 'recoil';
import { Atoms } from 'renderer/stores';
export var StatMain = function (props) {
    var _a, _b, _c;
    var isPC = useWindowSize().isPC;
    var storeId = (_a = props.store) === null || _a === void 0 ? void 0 : _a.id;
    var today = props.date ? dayjs(props.date) : dayjs();
    var managers = ManagerQuery.getWorkingManagersInCache();
    var _d = React.useState({
        startedAt: today.startOf('day').toDate(),
        endedAt: today.endOf('day').toDate(),
        managerId: props.readAll ? 'all' : (_b = props.loginManager) === null || _b === void 0 ? void 0 : _b.id
    }), values = _d[0], setValues = _d[1];
    React.useEffect(function () {
        var _a;
        setValues({
            startedAt: dayjs(props.date).startOf('day').toDate(),
            endedAt: dayjs(props.date).endOf('day').toDate(),
            managerId: props.readAll ? 'all' : (_a = props.loginManager) === null || _a === void 0 ? void 0 : _a.id
        });
    }, [props.date]);
    var handleChange = function (values) {
        setValues(values);
    };
    var stat = PaymentHistoryQuery.useSalesStatistics({
        storeId: storeId,
        startedAt: values.startedAt,
        endedAt: values.endedAt
    }, { enabled: !!storeId });
    var isAll = values.managerId === 'all';
    var paymentList = isAll
        ? stat.data
        : (_c = stat.data) === null || _c === void 0 ? void 0 : _c.filter(function (item) {
            return item.isManagerPayment(values.managerId);
        });
    var data = isEmpty(paymentList)
        ? { paidTotal: 0, total: 0 }
        : paymentList.reduce(function (prev, current) {
            return {
                paidTotal: prev.paidTotal + current.getPaidPriceByManagerId(values.managerId),
                total: prev.total + current.getTotalPriceByManagerId(values.managerId)
            };
        }, { paidTotal: 0, total: 0 });
    /**
     * 접객수 : 모든 유형의 매출의 숫자
     * 고객수 : 미등록 고객, 중복고객을 제외한 고객수
     */
    var customerIds = (paymentList === null || paymentList === void 0 ? void 0 : paymentList.map(function (sale) { return sale.customerId; })) || [];
    var convertedPaymentList = addPrepaid(paymentList);
    return stat.isLoading ? (React.createElement(EntireLoader, { open: true })) : (React.createElement("div", null,
        !props.date && (React.createElement(StatisticRemoteController, { managers: props.readAll ? managers : [props.loginManager], readAll: props.readAll, storeId: storeId, onChange: handleChange, values: values })),
        React.createElement(Row, null,
            React.createElement(TextComponent, { marginTop: 10, type: "subtitle1", children: "\uC2E4\uB9E4\uCD9C\uC561 ".concat(KRWFomatToString({ value: data === null || data === void 0 ? void 0 : data.paidTotal })) }),
            React.createElement(TextComponent, { marginTop: 10, type: "subtitle1", marginLeft: 20, children: "\uCD1D \uC601\uC5C5\uC561 ".concat(KRWFomatToString({
                    value: data === null || data === void 0 ? void 0 : data.total
                })) })),
        React.createElement(Row, null,
            React.createElement(TextComponent, { type: "subtitle2", color: COLORS.gray2, marginBottom: 20, children: "\uCD1D \uACE0\uAC1D\uC218 ".concat(KRWFomatWithoutWon({ value: uniq(customerIds.filter(Boolean)).length }), "\uBA85") }),
            React.createElement(TextComponent, { type: "subtitle2", marginLeft: 20, marginBottom: 20, color: COLORS.gray2, children: "\uCD1D\uC811\uAC1D ".concat(KRWFomatWithoutWon({ value: customerIds.length }), "\uAC74") })),
        React.createElement(Row, { gutter: 32, align: "top", justify: "space-around" },
            React.createElement(SalesTypePie, { paymentList: paymentList, isPC: isPC, managerId: values.managerId }),
            React.createElement(PaymentMethodStat, { paymentList: convertedPaymentList, isPC: isPC, store: props.store, managerId: values.managerId })),
        React.createElement(PaymentStatTable, { paymentList: convertedPaymentList, isPC: isPC, store: props.store, managerId: values.managerId }),
        React.createElement(SalesTable, { paymentList: paymentList, isPC: isPC, store: props.store })));
};
var PaymentStatTable = function (props) {
    var sales = props.paymentList || [];
    var dataKeys = [
        EXTENDED_SALES_METHODS.CARD,
        EXTENDED_SALES_METHODS.TRANSFER,
        EXTENDED_SALES_METHODS.CASH,
        EXTENDED_SALES_METHODS.NAVER_PAY,
        EXTENDED_SALES_METHODS.ETC1,
        EXTENDED_SALES_METHODS.ETC2,
        EXTENDED_SALES_METHODS.ETC3,
        EXTENDED_SALES_METHODS.ETC4,
        EXTENDED_SALES_METHODS.ETC5,
        EXTENDED_SALES_METHODS.UNPAID,
        'paidPrice',
        EXTENDED_SALES_METHODS.PREPAID_POINT,
        EXTENDED_SALES_METHODS.DEDUCTION_PRICE_BY_TICKET,
        EXTENDED_SALES_METHODS.CUSTOMER_POINT,
        EXTENDED_SALES_METHODS.DISCOUNT,
        'total'
    ];
    var valueableKeys = [];
    var dataSource = isEmpty(sales)
        ? []
        : ['service', 'product', 'ticket', 'refund', 'total'].map(function (key) {
            var result = {
                typeString: key === 'product'
                    ? '상품-제품'
                    : key === 'service'
                        ? '상품-시술'
                        : key === 'ticket'
                            ? '선불액∙정기권'
                            : key === 'refund'
                                ? '환불'
                                : '총계'
            };
            var filteredSPMS = [];
            if (key === 'total') {
                sales === null || sales === void 0 ? void 0 : sales.map(function (sale) {
                    filteredSPMS = filteredSPMS.concat(sale.salesPerManagers);
                });
            }
            else if (key === 'ticket') {
                sales
                    .filter(function (item) { return item.type === SALES_TYPES.TICKET; })
                    .map(function (sale) {
                    filteredSPMS = filteredSPMS.concat(sale.salesPerManagers);
                });
            }
            else if (key === 'product' || key === 'service') {
                sales.map(function (sale) {
                    var _a;
                    if (sale.isUsingHistory) {
                        (_a = sale.usingHistory) === null || _a === void 0 ? void 0 : _a.map(function (using) {
                            var _a, _b;
                            if (((_b = (_a = using.product) === null || _a === void 0 ? void 0 : _a.productGroup) === null || _b === void 0 ? void 0 : _b.type) === key) {
                                var spm = sale.salesPerManagers.filter(function (item) { return item.usingHistoryId === using.id; });
                                if (!isEmpty(spm)) {
                                    filteredSPMS.push.apply(filteredSPMS, spm);
                                }
                            }
                        });
                    }
                    else if (sale.type === SALES_TYPES.RESERVATION_FEE && key === 'service') {
                        sale.salesPerManagers.map(function (spm) { return filteredSPMS.push(spm); });
                    }
                });
            }
            else if (key === 'refund') {
                sales
                    .filter(function (item) { return item.type === SALES_TYPES.REFUND; })
                    .map(function (item) {
                    filteredSPMS = filteredSPMS.concat(item.salesPerManagers);
                });
            }
            filteredSPMS =
                !props.managerId || props.managerId === 'all'
                    ? filteredSPMS
                    : filteredSPMS.filter(function (item) { return props.managerId === item.managerId; });
            dataKeys.map(function (dataKey) {
                var sumValue = 0;
                if (dataKey === 'paidPrice') {
                    sumValue = sum(filteredSPMS.map(function (spm) { return spm.paidPrice; }));
                }
                else if (dataKey === 'total') {
                    sumValue = sum(filteredSPMS.map(function (spm) { return spm.totalPrice; }));
                }
                else if (dataKey === EXTENDED_SALES_METHODS.PREPAID_POINT) {
                    sumValue = sum(filteredSPMS.map(function (sale) {
                        return sale.methods &&
                            (sale.methods[EXTENDED_SALES_METHODS.PREPAID_POINT] || 0) +
                                (sale.methods[EXTENDED_SALES_METHODS.SHARED_PREPAID_POINT] || 0);
                    }));
                }
                else {
                    sumValue = sum(filteredSPMS.map(function (sale) { return (sale.methods && sale.methods[dataKey]) || 0; }));
                }
                if (sumValue) {
                    valueableKeys = uniq(valueableKeys.concat(dataKey));
                    result[dataKey] = sumValue;
                }
            });
            return result;
        });
    var columns = dataKeys
        .filter(function (item) {
        var _a, _b;
        return item !== 'total' && (((_b = (_a = props.store) === null || _a === void 0 ? void 0 : _a.paymentMethods[item]) === null || _b === void 0 ? void 0 : _b.active) || valueableKeys.includes(item));
    })
        .map(function (key) { return ({
        title: key === 'paidPrice' ? '실매출액' : SalesHistoryModel.getSalesMethodLabel(key, props.store),
        dataIndex: key,
        width: 100,
        key: key,
        render: function (value) { return KRWFomatToString({ value: value }); }
    }); });
    return (React.createElement(React.Fragment, null,
        React.createElement(TextComponent, { type: "subtitle2", children: "\uB9E4\uCD9C\uC720\uD615\uBCC4 \uC9D1\uACC4", marginTop: 15, marginBottom: 10 }),
        React.createElement(XScrollableTable, { resizable: { additionalColumnWidth: 0 }, id: 'TABLE_ID_SALES_STAT_TABLE', key: columns.length, rowKey: function (row, index) { return "".concat(index); }, rowClassName: function (record, index) { return clsx([record.typeString === '총계' && Styles.totalRow]); }, dataSource: dataSource, columns: __spreadArray(__spreadArray([
                {
                    title: '분류',
                    dataIndex: 'typeString',
                    width: 100
                }
            ], columns, true), [
                {
                    title: '총 영업액',
                    dataIndex: 'total',
                    width: 100,
                    render: function (value) { return KRWFomatToString({ value: value }); }
                }
            ], false) })));
};
var SalesTable = function (props) {
    var _a;
    var sales = orderBy(((_a = props.paymentList) === null || _a === void 0 ? void 0 : _a.filter(Boolean)) || [], 'paidAt', 'desc');
    var loginManager = ManagerQuery.getLoginManagerInCache();
    var duration = loginManager.getPermissionDurationDate({
        key: MANAGER_PERMISSION_KEYS.SALES_LIST,
        action: MANAGER_PERMISSION_ACTIONS_DURATION.READ_DURATION
    });
    var columns = getSalesTableColumns([
        'paidAt',
        'type',
        'manager',
        'customerName',
        'ticket',
        'totalPrice',
        'deduction',
        'methods',
        'paidPrice',
        'createCustomerPoint',
        'memo'
    ], duration);
    var _b = React.useState({ current: 1, total: sales.length, pageSize: 10 }), pagination = _b[0], setPagination = _b[1];
    var _c = useRecoilState(Atoms.salesModalState), setSalesDrawer = _c[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(TextComponent, { type: "subtitle2", children: "\uB9E4\uCD9C\uB0B4\uC5ED", marginTop: 15, marginBottom: 10 }),
        React.createElement(TextComponent, { type: "subtitle2", children: "\uCD1D ".concat(sales === null || sales === void 0 ? void 0 : sales.length, "\uAC74"), marginTop: 10, marginBottom: 10 }),
        React.createElement(Row, null,
            React.createElement(XScrollableTable, { resizable: { additionalColumnWidth: 0 }, id: 'TABLE_ID_SALES_STAT_ITEM_TABLE', pagination: pagination, onChange: function (pagination) {
                    setPagination(pagination);
                }, rowKey: function (row, index) { return "".concat(index); }, onRow: function (row) {
                    return {
                        onClick: function () {
                            var _a, _b;
                            var usingHistory = (_a = row.usingHistory) === null || _a === void 0 ? void 0 : _a.map(function (usingHistory) {
                                var _a;
                                var salesPerManagers = (_a = row.salesPerManagers) === null || _a === void 0 ? void 0 : _a.filter(function (spm) { return spm.usingHistoryId === usingHistory.id; });
                                return new UsingHistoryModel(__assign(__assign({}, usingHistory), { salesPerManagers: salesPerManagers }));
                            });
                            var tickets = (_b = row.tickets) === null || _b === void 0 ? void 0 : _b.map(function (ticket) {
                                var _a;
                                var salesPerManagers = (_a = row.salesPerManagers) === null || _a === void 0 ? void 0 : _a.filter(function (spm) { return spm.ticketId === ticket.id; });
                                return new TicketModel(__assign(__assign({}, ticket), { salesPerManagers: salesPerManagers }));
                            });
                            setSalesDrawer({
                                fixedCustomerId: !!row.customerId,
                                salesHistory: {
                                    data: new SalesHistoryModel(__assign(__assign({}, row), { usingHistory: usingHistory, tickets: tickets })),
                                    type: row.type
                                }
                            });
                        }
                    };
                }, dataSource: sales, columns: columns }))));
};
var PaymentMethodStat = function (props) {
    var isPC = props.isPC, paymentList = props.paymentList;
    // 미수금은 paidPrice에 들어가지 않지만 통계에 들어가기 때문에 더해줌
    var totalPaidPriceWithUnpaid = sum(paymentList === null || paymentList === void 0 ? void 0 : paymentList.map(function (payment) { return payment.getPaidPriceByManagerId(props.managerId) || 0; })) || 0;
    var getData = function () {
        var datasource = [
            EXTENDED_SALES_METHODS.CARD,
            EXTENDED_SALES_METHODS.TRANSFER,
            EXTENDED_SALES_METHODS.CASH,
            EXTENDED_SALES_METHODS.UNPAID,
            EXTENDED_SALES_METHODS.NAVER_PAY,
            EXTENDED_SALES_METHODS.ETC1,
            EXTENDED_SALES_METHODS.ETC2,
            EXTENDED_SALES_METHODS.ETC3,
            EXTENDED_SALES_METHODS.ETC4,
            EXTENDED_SALES_METHODS.ETC5,
            'paidPrice',
            EXTENDED_SALES_METHODS.DEDUCTION_PRICE_BY_TICKET,
            EXTENDED_SALES_METHODS.PREPAID_POINT,
            EXTENDED_SALES_METHODS.CUSTOMER_POINT,
            EXTENDED_SALES_METHODS.DISCOUNT,
            'total'
        ].map(function (key) {
            var name = key === 'total' ? '총계' : SalesHistoryModel.getSalesMethodLabel(key, props.store);
            var amount = 0;
            // FIXME: managerId가 있을 경우 salesPerManager에서 매출 액수를 구해야 정확하게 나옴
            var total = sum(paymentList === null || paymentList === void 0 ? void 0 : paymentList.map(function (payment) {
                var methods = props.managerId === 'all'
                    ? payment.methods || {}
                    : !payment.methods
                        ? {}
                        : Object.keys(payment.methods).reduce(function (prev, currentKey, index) {
                            var res = prev;
                            var spms = payment.salesPerManagers.filter(function (item) { return item.managerId === props.managerId; });
                            spms.map(function (spm) {
                                return (res[currentKey] =
                                    (res[currentKey] || 0) + (spm.methods ? spm.methods[currentKey] || 0 : 0));
                            });
                            return res;
                        }, {});
                var value = methods[key] || 0;
                if (key === EXTENDED_SALES_METHODS.PREPAID_POINT) {
                    value = value + (methods[EXTENDED_SALES_METHODS.SHARED_PREPAID_POINT] || 0);
                }
                if (value !== 0) {
                    amount = amount + 1;
                }
                return value;
            }));
            var percentage = floor((total / totalPaidPriceWithUnpaid) * 100, 1);
            return {
                key: key,
                name: name,
                percentage: isFinite(percentage) ? percentage : percentage === Infinity ? 100 : 0,
                total: total,
                amount: amount,
                totalPaidPriceWithUnpaid: totalPaidPriceWithUnpaid
            };
        });
        return orderBy(datasource, 'percentage', 'desc').filter(function (item) { return item.total !== 0; });
    };
    return (React.createElement(PieChartWrapper, { data: getData(), isPC: isPC, title: "\uACB0\uC81C\uC218\uB2E8", colors: [
            COLORS.staff2,
            COLORS.staff4,
            COLORS.staff1,
            COLORS.staff3,
            COLORS.staff5,
            COLORS.staff6,
            COLORS.staff7,
            COLORS.staff8,
            COLORS.staff9,
            COLORS.primary2
        ] }));
};
var SalesTypePie = function (props) {
    var isPC = props.isPC, paymentList = props.paymentList;
    // 미수금은 paidPrice에 들어가지 않지만 통계에 들어가기 때문에 더해줌
    var totalPaidPriceWithUnpaid = sum(paymentList === null || paymentList === void 0 ? void 0 : paymentList.map(function (payment) { return payment.getPaidPriceByManagerId(props.managerId) || 0; })) || 0;
    var getData = function () {
        var datasource = ['service', 'product', 'ticket', 'refund'].map(function (key) {
            var name = key === 'ticket' ? '선불액∙정기권' : key === 'refund' ? '환불' : key === 'service' ? '상품-시술' : '상품-제품';
            var amount = 0;
            // FIXME: managerId가 있을 경우 salesPerManager에서 매출 액수를 구해야 정확하게 나옴
            var total = sum(paymentList === null || paymentList === void 0 ? void 0 : paymentList.map(function (payment) {
                var _a, _b;
                if ((key === 'ticket' && payment.type !== 'ticket') ||
                    ((key === 'service' || key === 'product') &&
                        !['product', 'reservationFee', 'sales', 'service'].includes(payment.type)) ||
                    (key === 'refund' && payment.type !== 'refund')) {
                    return 0;
                }
                if (key === 'service' || key === 'product') {
                    if (payment.type === 'reservationFee' && key === 'service') {
                        return payment.getPaidPriceByManagerId(props.managerId);
                    }
                    else {
                        var salesPerManagers = ((_a = payment.salesPerManagers) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return item.managerId === props.managerId || props.managerId === 'all'; })) || [];
                        return sum((_b = salesPerManagers
                            .filter(function (item) {
                            var _a, _b;
                            return ((_b = (_a = payment.usingHistory) === null || _a === void 0 ? void 0 : _a.find(function (using) { return item.usingHistoryId === using.id; })) === null || _b === void 0 ? void 0 : _b.type) === key;
                        })) === null || _b === void 0 ? void 0 : _b.map(function (spm) { return spm.paidPrice; }));
                    }
                }
                else {
                    return payment.getPaidPriceByManagerId(props.managerId);
                }
            }));
            var percentage = floor((total / totalPaidPriceWithUnpaid) * 100, 1);
            return {
                key: key,
                name: name,
                percentage: isFinite(percentage) ? percentage : percentage === Infinity ? 100 : 0,
                total: total,
                amount: amount,
                totalPaidPriceWithUnpaid: totalPaidPriceWithUnpaid
            };
        });
        return datasource;
    };
    return (React.createElement(PieChartWrapper, { data: getData(), isPC: isPC, title: "\uB9E4\uCD9C\uC720\uD615 (\uC2E4\uB9E4\uCD9C\uC561)", colors: [COLORS.tag6, COLORS.staff4, COLORS.tag5, COLORS.staff1] }));
};
var PieChartWrapper = function (props) {
    var isPC = props.isPC, data = props.data, title = props.title, _a = props.colors, colors = _a === void 0 ? [COLORS.staff2, COLORS.staff4, COLORS.staff3, COLORS.staff1] : _a;
    var chartWrapperProps = isPC ? {} : { span: 24 };
    var legendWrapperProps = isPC ? { flex: 1 } : { span: 24 };
    var isEmptyData = !data || isEmpty(data) || !sum(data === null || data === void 0 ? void 0 : data.map(function (item) { return item.total || 0; }));
    var MORE_COUNT = 4;
    var hasMore = data.length > MORE_COUNT;
    var _b = React.useState(isPC), isCollapsed = _b[0], setIsCollapsed = _b[1];
    return (React.createElement(Col, { span: isPC ? 12 : 24 },
        React.createElement(TextComponent, { type: "subtitle2", children: title, marginTop: 15, marginBottom: 10 }),
        isEmptyData ? (React.createElement(Empty, null)) : (React.createElement(Row, { gutter: 16, justify: "center" },
            React.createElement(Col, __assign({}, chartWrapperProps),
                React.createElement(Row, { justify: "center", style: { width: '100%' } },
                    React.createElement(CustomedPieChart, { data: data, colors: colors, width: 300, height: 250 }))),
            React.createElement(Col, __assign({}, legendWrapperProps),
                __spreadArray([], data, true).map(function (item, index) {
                    return isPC && isCollapsed && index > MORE_COUNT ? (React.createElement("div", null)) : (React.createElement(LegendItem, { key: item.key, label: item.name, amount: item.amount, total: item.total, color: colors[index], order: index + 1 }));
                }),
                hasMore && isPC && (React.createElement(ClickableText, { onClick: function () { return setIsCollapsed(!isCollapsed); }, children: isCollapsed ? '더 보기 >' : '접기 >', type: "caption1", color: COLORS.primary1, textAlign: "right" })))))));
};
export var addPrepaid = function (items) {
    return ((items === null || items === void 0 ? void 0 : items.map(function (item) {
        var _a = (item === null || item === void 0 ? void 0 : item.methods) || {}, prepaidPoint = _a.prepaidPoint, sharedPrepaidPoint = _a.sharedPrepaidPoint, rest = __rest(_a, ["prepaidPoint", "sharedPrepaidPoint"]);
        return new SalesHistoryModel(__assign(__assign({}, item), { methods: __assign({ prepaidPoint: (prepaidPoint || 0) + (sharedPrepaidPoint || 0), sharedPrepaidPoint: 0 }, rest) }));
    })) || []);
};
